/**
 * TanStack Query helpers for tenant-scoped data.
 *
 * Admin users scope API calls via X-Admin-Tenant-ID (localStorage). When the
 * active tenant changes, every cached query must be dropped so refetches use
 * the new header. Prefer clearTenantQueryCache() in one place (Provider +
 * select-tenant mutation) instead of sprinkling tenantId into every query key.
 */

/** Prefix for query keys that are explicitly tenant-scoped (optional defence). */
export const TENANT_SCOPE_KEY = 'tenant-scope';

/**
 * Build a query key segment that includes the active tenant scope.
 * Use via useTenantScopedQueryKey() in hooks.
 */
export function buildTenantScopedQueryKey(tenantScopeId, ...segments) {
  return [TENANT_SCOPE_KEY, tenantScopeId ?? 'none', ...segments];
}

/**
 * Wipe the React Query cache after a tenant switch.
 * Safe to call multiple times; idempotent from a correctness standpoint.
 */
export function clearTenantQueryCache(queryClient) {
  queryClient.clear();
}
